import { render, staticRenderFns } from "./FormGroupFour.vue?vue&type=template&id=36dcc809&scoped=true&"
import script from "./FormGroupFour.vue?vue&type=script&lang=js&"
export * from "./FormGroupFour.vue?vue&type=script&lang=js&"
import style0 from "./FormGroupFour.vue?vue&type=style&index=0&id=36dcc809&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dcc809",
  null
  
)

export default component.exports